module.exports = __webpack_public_path__ + "static/top-451911edee229dcefa45233302ce207a.png";